import { render, staticRenderFns } from "./PaymentNewWays.vue?vue&type=template&id=1decef6a&scoped=true"
import script from "./PaymentNewWays.vue?vue&type=script&lang=ts"
export * from "./PaymentNewWays.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewWays.vue?vue&type=style&index=0&id=1decef6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1decef6a",
  null
  
)

export default component.exports